import Ajax from '../util/ajax';
export function fetchZigbeeSimpleDescriptors(zigbee_node_id) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/zigbee/' + zigbee_node_id + '/simpledescs';
        ajax.post(url);
    };
}
